'use strict';

import {ItemEditCtrl} from "./itemeditctrl.js";

export class ItemPreviewCtrl extends ItemEditCtrl
{
	pdfLoading = false;
	downloadName = 'file.pdf';
	
	getClassifValue(classifName, idValue){
		if(typeof(this.classif[classifName]) !== 'undefined'){
			for(let el of this.classif[classifName]){
				if(el.id == idValue){
					return el.title;
				}
			}
		}
		return '';
	}
	
	nonZeroValue(value){
		if(value == 0){
			return '';
		}
		return value;
	}
	
	fieldVisible(fieldName){
		if(typeof(this.cfg.field[fieldName]) === 'undefined' || !this.cfg.field[fieldName].preview){
			return false;
		}
		return true;
	}

	filterField(field){
		switch(field){
			case 'created':
			case 'updated':
				if(!this.fieldVisible(field)){
					return;
				}
				return this.item[field]>0?this.$filter('u2date')(this.item[field], 'yyyy-MM-dd HH:mm'):'';
			case 'status':
				if(!this.fieldVisible('status')){
					return;
				}
				if(typeof(this.item[field+'_title']) !== 'undefined'){
					return this.item[field+'_title'];
				}
				return '';
			case 'user':
				if(!this.fieldVisible('user_id')){
					return;
				}
				if(typeof(this.item[field+'_title']) !== 'undefined'){
					return this.item[field+'_title'];
				}
				return '';
			case 'initial_type_id':
				if(!this.fieldVisible('initial_type_id')){
					return;
				}
				if(typeof(this.item[field+'_title']) !== 'undefined'){
					return this.item[field+'_title'];
				}
				break;
			case 'type_id':
				if(!this.fieldVisible('type_id')){
					return;
				}
				if(typeof(this.item[field+'_title']) !== 'undefined'){
					return this.item[field+'_title'];
				}
				return this.getClassifValue('types', this.item.type_id);
			case 'initial_location_id':
				if(!this.fieldVisible('initial_location_id')){
					return;
				}
				if(typeof(this.item[field+'_title']) !== 'undefined'){
					return this.item[field+'_title'];
				}
				return this.getClassifValue('locations', this.item.initial_location_id);
			case 'location_id':
				if(!this.fieldVisible('location_id')){
					return;
				}
				if(typeof(this.item[field+'_title']) !== 'undefined'){
					return this.item[field+'_title'];
				}
				return this.getClassifValue('locations', this.item.location_id);
			case 'initial_status_id':
				if(!this.fieldVisible('initial_status_id')){
					return;
				}
				if(typeof(this.item[field+'_title']) !== 'undefined'){
					return this.item[field+'_title'];
				}
				return this.getClassifValue('status', this.item.initial_status_id);
			case 'status_id':
				if(!this.fieldVisible('status_id')){
					return;
				}
				if(typeof(this.item[field+'_title']) !== 'undefined'){
					return this.item[field+'_title'];
				}
				return this.getClassifValue('status', this.item.status_id);
		}

		if(typeof(this.item[field]) === 'undefined'){
			return '';
		}

		return this.item[field];

	}
}
